import React, { Component } from 'react';
import './index.css';
import apiurl from './apiurl';
import axios from 'axios';
import swal from 'sweetalert';

export default class Opiniuj2 extends React.Component {
constructor(props) {
  super(props);    
  this.state = {
    token: sessionStorage.getItem('token'),
    status: "P",
    uwaga: props.uwagi,
  }

}

componentDidMount() {
  this.opiniowaniModalGet()
}

opiniowaniModalGet() {
  axios
  .get(apiurl+"api/Opinie2/Opiniodawcy", { params: { rok: this.props.rok, idUchwaly: this.props.idUchwaly, idWydzialu: this.props.idWydzialu }, headers: { 'Authorization' : "Bearer " + this.state.token }})
  .then(response =>
    this.setState({ opiniowanieData: response.data })
  )
  .catch(error => swal(error.response.data));
}

post = () => {
  const dataNow = new Date();
  if(this.state.uwaga && this.state.opiniowanieValue) {
    axios.post(apiurl+"api/Opinie2/Post2",{
        id: this.props.idopini, 
        rok: this.props.rok, 
        idUchwaly: this.props.idUchwaly, 
        idWydzialu: this.props.idWydzialu, 
        status: this.state.status, 
        uwagi: this.state.uwaga, 
        dataZamk: dataNow },
        {headers : {'Content-Type': 'application/json' , 'Authorization' : "Bearer " + this.state.token } })
        .then(res => {
          this.postOpiniodawca();
        })
    .catch(error => swal(error.response.data));
  } else if(this.state.uwaga) { 
    axios.post(apiurl+"api/Opinie2/Post2",{
      id: this.props.idopini, 
      rok: this.props.rok, 
      idUchwaly: this.props.idUchwaly, 
      idWydzialu: this.props.idWydzialu, 
      status: this.state.status, 
      uwagi: this.state.uwaga, 
      dataZamk: dataNow 
    }, {headers : {'Content-Type': 'application/json' , 'Authorization' : "Bearer " + this.state.token } })
    .then(res => {
      swal('Zapisano opinie');
      this.props.getData1();
      this.props.closeModal2();
    })
    .catch(error => swal(error.response.data));
  } else { swal('Wprowadź uwagi')}
}

postOpiniodawca = () => {
    const data = JSON.parse(this.state.opiniowanieValue);
    const dataNow = new Date();
  
    axios.post(apiurl+"api/Opinie2/Post1", {
      id: this.props.idopini,
      rok: Number(this.props.rok),
      idUchwaly: Number(this.props.idUchwaly),
      idWydzialu: Number(this.props.idWydzialu),
      idOpiniodawcyDo: data.idOpiniodawcy,
      kodOperDo: data.kodOper,
      dataOtw: dataNow,
      kodOper: null,
      idOpiniodawcy: null,
      uwagi: null,
      status: null,
      dataZamk: null,
      nazwaWydzialu: null,
      nazwaUchwaly: null,
    },
    {headers : {'Content-Type': 'application/json' , 'Authorization' : "Bearer " + this.state.token } })
    .then(res => {
      swal('Zapisano');
      this.props.getData1();
      this.props.closeModal2();
    })
    .catch(error => {
        swal(error.response.data ? error.response.data : 'Zapisywanie opiniującego nie powiodło się.') 
    });
  }

onChange = (e) => { this.setState({  [e.target.name]: e.target.value }); }


render() {
const { opiniowanieData } = this.state;

return (
<React.Fragment>
<div className="container-fluid">
<h1>Opiniuj</h1>
<hr />

<div className='d-flex flex-row'>
  <h5>Opiniujesz jako: <b>{this.props.nazwaOpiniodawcyDo}</b></h5>
</div>

<div className="d-flex flex-row">
  <div class=" float-left mt-2 mb-4">
    <span>Status:</span>
    <select class="form-control" name="status" onChange={this.onChange.bind(this)}>
    <option key="1" value="P">Pozytywny</option>
    <option key="2" value="N">Negatywny</option>
    <option key="3" value="Z">Zignorowany</option>
    </select>
  </div>
</div>

<div className="d-flex flex-row">
  <div class="flex-column w-100">
    <span>Uzasadnienie:</span>
    <textarea class="form-control" name="uwaga" value={this.state.uwaga} onChange={this.onChange.bind(this)} rows="6"></textarea>
  </div>
</div>

<div className='d-flex flex-row mt-2 mb-1'>
  <div class="flex-column w-100">
    <span>Następny opiniujący:</span>
    {opiniowanieData ? (<><select class="form-control p-2" id="selectOpiniowanie"  onChange={(e) => (this.setState({ opiniowanieValue: e.target.value}))}><option disabled selected hidden>Wybierz</option>{opiniowanieData.map((data, idx) => { const value = JSON.stringify(data); return (<>{data.pomin === 'N' ? (<option key={idx} value={value}>{data.nazwaOpiniodawcy}, {data.czyOpiniowal}</option>) : null }</>) } )}</select></>) : (<div className='d-flex flex-row justify-content-center w-100'><div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div></div>) }
  </div>
</div>

<div className="d-flex flex-row">
<div class="flex-column w-100">
<button  onClick={() => {
  if(this.state.status === 'N'){
    swal({
      title: 'Wybranie negatywnej statusu usunie dotychczasowe opinie. Edycja dla wydziałów zostanie otwarta. Proces opiniowania będzie można rozpocząć na nowo',
      buttons: {
      cancel: "Anuluj",
      catch: {
        text: "OK",
        value: "willDelete",} 
      },
      dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        this.post();
      } 
    });
  } else {
    swal({
      title: "Czy na pewno chcesz zapisać?",
      buttons: {
      cancel: "Anuluj",
      catch: {
        text: "Zapisz",
        value: "willSave",} 
      },
      dangerMode: true,
    })
    .then((willSave) => {
      if (willSave) {
        this.post();
      } 
    });
  }
}} type="button" class="btn btn-light float-right m-2" >Zapisz</button>
</div>
</div>

</div>
</React.Fragment>
);
}
}


